var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelay(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    style: {
      enableBackground: "new 0 0 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A09C8A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.5,21c-2.2,0-4.4-0.8-6-2.5c-0.3-0.3-0.3-0.7,0-0.9c0.3-0.3,0.7-0.3,0.9,0c2.8,2.8,7.4,2.8,10.3,0 c2.8-2.8,2.8-7.4,0-10.3s-7.4-2.8-10.3,0C7,7.6,6.7,7.6,6.4,7.4c-0.3-0.3-0.3-0.7,0-0.9c3.3-3.3,8.7-3.3,12.1,0s3.3,8.7,0,12.1 C16.9,20.2,14.6,21,12.5,21z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.5,15.7c-0.2-0.3,0-0.8,0.3-0.8l0,0c0.3-0.2,0.7,0,0.8,0.3l0,0c0.2,0.3,0,0.7-0.3,0.8l0,0 c-0.1,0-0.2,0.1-0.3,0.1l0,0C4.9,16,4.7,15.9,4.5,15.7z M3.9,13.2L3.9,13.2L3.9,13.2c0-0.3,0.3-0.7,0.6-0.7l0,0 c0.3,0,0.7,0.3,0.7,0.6l0,0c0,0.3-0.3,0.7-0.6,0.7l0,0H4.5l0,0C4.3,13.9,3.9,13.5,3.9,13.2z M4.6,11.5C4.3,11.4,4,11,4.1,10.7l0,0 c0.1-0.3,0.4-0.6,0.8-0.5l0,0c0.3,0.2,0.5,0.5,0.4,0.9l0,0C5.3,11.3,5.1,11.5,4.6,11.5L4.6,11.5C4.7,11.5,4.6,11.5,4.6,11.5z  M5.3,9.2C5,9.1,4.8,8.7,5.1,8.3l0,0C5.2,8,5.7,7.9,5.9,8.1l0,0c0.3,0.2,0.4,0.6,0.3,0.9l0,0C6,9.2,5.7,9.3,5.5,9.3l0,0 C5.4,9.3,5.3,9.3,5.3,9.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.1,13.9h-2.7c-0.3,0-0.7-0.3-0.7-0.7c0-0.3,0.3-0.7,0.3-0.7h2.7c0.8,0,1,0.3,1,0.7 C15.7,13.5,15.5,13.9,15.1,13.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,13.9c-0.3,0-0.7-0.3-0.7-0.8V8.8c0-0.4,0.3-0.8,0.7-0.8s0.7,0.3,0.7,0.8v4.3 C12.8,13.5,12.4,13.9,12.1,13.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.1,20.6c-0.3,0-0.6-0.3-0.7-0.6l-0.3-2c-0.1-0.3,0.2-0.7,0.6-0.8l2-0.1c0.3-0.1,0.7,0.2,0.8,0.6 c0.1,0.3-0.2,0.7-0.6,0.8l-1.3,0.2l0.2,1.2C7.9,20.3,7.6,20.5,7.1,20.6C7.2,20.6,7.2,20.6,7.1,20.6z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelay);
export default __webpack_public_path__ + "static/media/delay.d36c506059201dbd0f3e0899071f9d38.svg";
export { ForwardRef as ReactComponent };